import { Button, Modal, Switch } from "@deligoo/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { EVENTS_TABLE_HEADERS as columns, EventsTableHeader } from "./EventsList"
import cls from "./StatisticsFilterModal.module.scss"

type StatisticsFilterModalProps = {
  hiddenColumns: EventsTableHeader[]
  setHiddenColumns: Dispatch<SetStateAction<EventsTableHeader[]>>
  sortTeamsByPriority?: boolean
  setSortTeamsByPriority?: Dispatch<SetStateAction<boolean>>
  handleClose: () => void
}

export const StatisticsFilterModal = ({
  hiddenColumns,
  setHiddenColumns,
  sortTeamsByPriority,
  setSortTeamsByPriority,
  handleClose,
}: StatisticsFilterModalProps) => {
  const columnsWithoutName = columns.filter((column) => column !== "name")

  const { t } = useTranslation()

  function onOptionClick(column: EventsTableHeader) {
    const isAlreadySelected = hiddenColumns.includes(column)

    if (isAlreadySelected) {
      setHiddenColumns([...hiddenColumns.filter((hiddenColumn) => hiddenColumn !== column)])
    } else {
      setHiddenColumns([...hiddenColumns, column])
    }
  }

  return (
    <Modal handleClose={handleClose} className={cls.modal} closeBtnPosition="inside">
      <Modal.Content>
        {setSortTeamsByPriority && (
          <Switch
            checked={sortTeamsByPriority}
            onChange={() => setSortTeamsByPriority((value: boolean) => !value)}
            size="small"
            className="mb-6 d-flex"
            labelClassName="text-large font-weight-bold"
          >
            Sortowanie po priorytetach
          </Switch>
        )}

        <div className="h400 text-center mb-6">Ukryj parametry statystyk</div>

        <div className={cls.columns}>
          {columnsWithoutName.map((column) => (
            <Button
              onClick={() => onOptionClick(column)}
              color={hiddenColumns.includes(column) ? undefined : "primary"}
              key={column}
            >
              {t(`stats.list.${column}`)}
            </Button>
          ))}
        </div>
      </Modal.Content>
    </Modal>
  )
}
